module.exports = __webpack_public_path__ + "img/editor.a05f0d77.svg";